import { useEffect, useState } from 'react';
import { useEmojiMenu } from '@ametista-ai/editor/plugins/EmojiPlugin/store';
import { clearFloatingTrigger } from '@ametista-ai/editor/utils';
import { Emoji as EmojiMartEmoji } from '@emoji-mart/data';
import { useEditorEventCallback } from '@handlewithcare/react-prosemirror';
import { SearchIndex } from 'emoji-mart';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Group, Stack, Text } from '@mantine/core';
import { Emoji } from '@/ui/Emoji/Emoji';
import { getEmojiData } from '@/utils/emoji';
import { FloatingMenu } from '../FloatingMenu/FloatingMenu';
import { FloatingMenuItem } from '../FloatingMenu/FloatingMenuItem';

const DEFAULTS = [
  '+1',
  'grinning',
  'kissing_heart',
  'heart_eyes',
  'laughing',
  'stuck_out_tongue_winking_eye',
  'sweat_smile',
  'joy',
  'scream',
  'disappointed',
  'unamused',
  'weary',
  'sob',
  'sunglasses',
  'heart',
];

export const EmojiMenu = observer(() => {
  const store = useEmojiMenu();

  const [options, setOptions] = useState<EmojiMartEmoji[]>([]);

  const handleAddEmoji = useEditorEventCallback((view, emoji: EmojiMartEmoji) => {
    clearFloatingTrigger(view, store.query, ':');

    view.dispatch(view.state.tr.insertText(emoji.skins[0].native));
    view.focus();

    store.setOpen(false);
  });

  useEffect(
    () =>
      reaction(
        () => store.query,
        async (query) => {
          const emojis = await SearchIndex.search(query ?? '');
          setOptions(emojis);
        }
      ),
    [store.query]
  );

  if (!store.open) return null;

  const finalOptions = options?.length ? options : DEFAULTS.map((id) => getEmojiData(id));

  return (
    <FloatingMenu onOpenChange={(opened) => store.setOpen(opened)}>
      <Stack gap={0}>
        {finalOptions?.map((option, index) => (
          <FloatingMenuItem
            key={option.id}
            itemIndex={index}
            onClick={() => handleAddEmoji(option)}
          >
            <Group gap="xs">
              <Emoji emoji={option} />
              <Text size="xs">{option.id}</Text>
            </Group>
          </FloatingMenuItem>
        ))}
      </Stack>
    </FloatingMenu>
  );
});
